import Question from './question';
import MultiChoiceArrayTool from '../tools/multi-choice-array/multi-choice-array-tool';

export default class MultiChoiceArrayQuestion extends Question {
  /**
   * @typedef {Array.<number>} MultiChoiceOption - array of length 2, both items integer in range [0,13]
   */

  /**
   * @property {MultiChoiceOption} answer
   */

  /**
   * @constructor
   * @param {Object}                    [config]
   * @param {Array.<MultiChoiceOption>} [config.multiChoiceOptions] - length 4
   */
  constructor({ multiChoiceOptions } = {}) {
    super(...arguments);

    if ( !multiChoiceOptions ) {
      const potentialBadOptions = [
        [ this.multiplicand - 1, this.multiplier ],
        [ this.multiplicand + 1, this.multiplier ],
        [ this.multiplicand, this.multiplier - 1 ],
        [ this.multiplicand, this.multiplier + 1 ],
        [ this.multiplicand - 1, this.multiplier - 1 ],
        [ this.multiplicand + 1, this.multiplier + 1 ]
      ];

      const options = [ [ this.multiplicand, this.multiplier ] ];
      options.push(potentialBadOptions.splice(Math.floor(Math.random() * potentialBadOptions.length), 1)[ 0 ]);
      options.push(potentialBadOptions.splice(Math.floor(Math.random() * potentialBadOptions.length), 1)[ 0 ]);
      options.push(potentialBadOptions.splice(Math.floor(Math.random() * potentialBadOptions.length), 1)[ 0 ]);

      multiChoiceOptions = [];
      while ( options.length ) {
        multiChoiceOptions.push(options.splice(Math.floor(Math.random() * options.length), 1)[ 0 ]);
      }
    }

    this.config.multiChoiceOptions = multiChoiceOptions;
  }

  get tool() {
    return MultiChoiceArrayTool;
  }
  get title() {
    return [ 'Here is an array.', 'What multiplication is shown?' ];
  }
  get result() {
    return this.optionIsCorrectAnswer(this.answer);
  }
  get multiChoiceOptions() {
    return this.config.multiChoiceOptions;
  }

  optionIsCorrectAnswer( option ) {
    return Array.isArray(option) &&
        option[ 0 ] === this.multiplicand &&
        option[ 1 ] === this.multiplier;
  }
}
